import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isEmpty } from "../../utils/nativeUtils";
import { Fragment, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { WithSearch } from "@elastic/react-search-ui";
import { Spinner } from "../common/Spinner";
import { ResultBox } from "./../results/ResultBox";
import { CustomPaging } from "./pagination/CustomPaging";
import "./results.css";
import { ResultsHeader } from "./header/ResultsHeader";
const ResultsList = () => {
    function renderNoResultsMessage(resultSearchTerm) {
        return (_jsxs("div", { className: "no-results-page", children: [_jsx("h2", { className: "no-results-message", "data-testid": "noResultsMessage", children: _jsx(FormattedMessage, { id: "noResults.sorry", values: { searchTerm: resultSearchTerm } }) }), _jsx(FormattedMessage, { id: "noResults.tryAgain" }), _jsxs("ul", { className: "no-results-suggestions-list", children: [_jsx("li", { children: _jsx(FormattedMessage, { id: "noResultsSuggestions.checkSpelling" }) }), _jsx("li", { children: _jsx(FormattedMessage, { id: "noResultsSuggestions.broadenSearch" }) }), _jsx("li", { children: _jsx(FormattedMessage, { id: "noResultsSuggestions.useDifferentTerms" }) }), _jsx("li", { children: _jsx(FormattedMessage, { id: "noResultsSuggestions.visitSupport" }) })] })] }));
    }
    return (_jsx(WithSearch, { mapContextToProps: ({ results, wasSearched, resultSearchTerm }) => ({ results, wasSearched, resultSearchTerm }), children: ({ resultSearchTerm, wasSearched, results }) => (_jsx(Fragment, { children: wasSearched && (_jsx("div", { className: "result-list", "data-testid": "resultList", children: !!results && !isEmpty(results)
                    ? results.map((result) => _jsx(ResultBox, { result: result }, result.id.raw))
                    : renderNoResultsMessage(resultSearchTerm) })) })) }));
};
/**
 * Renders the results part of the result page view
 * @param results list of results
 */
export const Results = ({ results }) => {
    useEffect(() => {
        const resultList = document.getElementById("result-list");
        const isInMobileView = window.innerWidth < 800;
        if (!!resultList && !isInMobileView) {
            resultList.scrollIntoView({ behavior: "smooth" });
        }
    }, [results]);
    return (_jsx(WithSearch, { mapContextToProps: ({ wasSearched, isLoading }) => ({
            wasSearched,
            isLoading,
        }), children: (context) => {
            const showResultsAndResultInfo = !context.isLoading && context.wasSearched;
            return (_jsxs("div", { className: "sui-layout-main", id: "result-list", children: [_jsx(ResultsHeader, {}), _jsx("div", { className: "sui-layout-main-body", children: context.isLoading ? _jsx(Spinner, {}) : _jsx(ResultsList, {}) }), showResultsAndResultInfo && (_jsx("div", { className: "sui-layout-main-footer", children: _jsx(CustomPaging, {}) }))] }));
        } }));
};
